import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISize } from "../sizeSlice";

export const getAllSize = createAsyncThunk("Size/FindAllSize", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Size/FindAllSize`,
      {
        Size: "",
      }
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching Size:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createSize = createAsyncThunk(
  "Size/InsertSize",
  async (SizeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Size/InsertSize`,
        SizeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Size:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateSize = createAsyncThunk(
  "Size/UpdateSize",
  async (SizeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Size/UpdateSize`,
        SizeData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Size :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteSize = createAsyncThunk(
  "Size/DeleteSize",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Size/DeleteSize`,
        {
          ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Size :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getSizeByID = createAsyncThunk(
  "Size/FindByIDSize",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Size/FindByIDSize`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Size: result.Size,
        IsActive: result.IsActive ? 1 : 2,
      } as ISize;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Size :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveSize = createAsyncThunk(
  "Size/FindAllActiveSize",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Size/FindAllActiveSize`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Sizees:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveSize = createAsyncThunk(
  "Size/ActiveInActiveSize",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Size/ActiveInActiveSize`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Size :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
